
import design from "./design.pdf";
import logo from "./chilax-trans.png";

export const docs={

design,
logo

}